import styled from 'styled-components';

import { FlexBox, system, SystemProps } from '@sternum/styled-system';
import { Tag, TextInput } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const InputWithTagsStyled = styled(FlexBox)<SystemProps>`
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  overflow: auto;

  ${system}
`;

export const TextInputStyled = styled(TextInput)`
  flex: 1 1;
  padding: 0;
  border: none;
`;

export const TagStyled = styled(Tag)`
  background-color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;
